import React from 'react';
import { Flex, Stack } from '@atlaskit/primitives';
import { SkeletonLoader, SkeletonLoaderWrapper } from '@css-xp/skeleton-loader';

interface Props {
  testId?: string;
  hideActions?: boolean;
  hasLeftIcon?: boolean;
  hasSubheading?: boolean;
}

export const PageHeaderLoader = ({
  testId = 'page-header-loader',
  hideActions = false,
  hasLeftIcon = false,
  hasSubheading = false,
}: Props) => {
  const headerHeight = '28px';
  const iconDimension = hasSubheading ? '48px' : headerHeight;

  return (
    <div data-testid={testId} className="mt-32 mb-24">
      <SkeletonLoaderWrapper>
        {/* Breadcrumb */}
        <SkeletonLoader width="20%" height="12px" marginBottom="14px" />
      </SkeletonLoaderWrapper>
      <SkeletonLoaderWrapper>
        <Flex>
          {/* Left icon */}
          {hasLeftIcon && (
            <Stack>
              <SkeletonLoader width={iconDimension} height={iconDimension} marginRight="1rem" />
            </Stack>
          )}
          <Stack grow="fill">
            {/* Heading */}
            <SkeletonLoader width="35%" height={headerHeight} marginBottom="8px" />
            {hasSubheading && <SkeletonLoader width="30%" height="12px" />}
          </Stack>
          {/* Right action CTA */}
          {hideActions || <SkeletonLoader width="10%" isRightAligned />}
        </Flex>
      </SkeletonLoaderWrapper>
    </div>
  );
};
